// extracted by mini-css-extract-plugin
module.exports = {"secondaryRatingContainer":"az_-Ld","ratingContainer":"az_-Md","rectangle":"az_-Nd","active":"az_-Od"};